import type { EndpointDefinition } from "../../../_sdk/types/common";

export const apiName = "workspaces";

export const endpoints: { [key: string]: EndpointDefinition } = {
    getWorkspaceStripeData: {
        route: "/workspaces/:workspaceId/billing/stripe",
        method: "GET"
    }
};
